<template>
  <div class="cy-vertical-stepper">
    <v-stepper tile v-model="stepIndex" vertical>
      <template v-for="step in steps">
        <v-stepper-step
          :rules="stepRules(step.component)"
          :id="'step-' + $toSnake(step.component)"
          :key="'step-' + step.index"
          :step="step.index + 1"
          :complete="stepIndex > step.index"
          @click="setStepByIndex(step.index)"
          :class="{ 'cursor-pointer': step.index !== stepIndex }"
        >
          <span
            class="text-uppercase text-h5 w-100"
            :class="{ 'black--text': true }"
            v-t="step.title"
          />
        </v-stepper-step>

        <v-stepper-content :key="'step-content-' + step.index" :step="step.index">
          <component
            id="stepper-content"
            :is="step.component"
            @previous="previous()"
            @next="next()"
          ></component>

          <div class="d-flex justify-space-between mt-10 mb-6">
            <div>
              <base-btn
                tile
                color="primary"
                @click="next()"
                v-if="$store.getters.currentStep.nextStep"
              >
                <span class="mx-5" v-t="'Continue'" />
                <v-icon right>mdi-chevron-down</v-icon>
              </base-btn>
            </div>
            <base-btn tile text @click="previous()"><span v-t="'Back'" /></base-btn>
          </div>
          <div v-if="showStepErrorNotice">
            <v-alert type="error" outlined text>
              <div class="mb-3" v-t="'This step contains errors.'" />
              <base-btn class="ma-1" color="primary" @click="$vuetify.goTo('#stepper-content', {})">
                <span v-t="'Fill required fields'" />
                <v-icon right>mdi-chevron-up</v-icon>
              </base-btn>
              <base-btn class="ma-1" @click="next(false)" text outlined>
                <span v-t="'I\'ll come back later'" />
                <v-icon right>mdi-chevron-down</v-icon>
              </base-btn>
            </v-alert>
          </div>
        </v-stepper-content>
      </template>
    </v-stepper>
  </div>
</template>

<script>
import stepperMixin from "./stepperMixin";

export default {
  mixins: [stepperMixin],

};
</script>

<style lang="scss">
</style>
